import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { clients } from '../../mockData';
import './List.css';

function ClientsList() {
  const { Title } = Typography;

  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Contact', dataIndex: 'contact', key: 'contact' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'active' ? 'green' : 'default'}>{s.toUpperCase()}</Tag> },
  ];

  return (
    <div className="agency-clients-list">
      <Title level={3}>Clients</Title>
      <Table rowKey="id" columns={columns} dataSource={clients} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default ClientsList;
